"use client";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { ButtonGroup } from "ui/core/button-group";

import { getCategoryOptions } from "../data/category-options";
import { ForecastCategory } from "../services/financial-forecast-chart";

type Props = {
  category: ForecastCategory;
};

export const CategoryToggle = ({ category }: Props) => {
  const { t } = useLang();
  const options = getCategoryOptions({ t });
  const { updateQuery } = useUpdateQuery();

  const onClick = (value: string) => {
    updateQuery({ name: "category", value });
  };

  return (
    <ButtonGroup
      className="min-w-[280px]"
      options={options}
      onButtonClick={onClick}
      activeId={category}
    />
  );
};
